/* src/components/pages/Conciliacion.jsx - Modificado el 24-03-2026 */
/* ------------ conciliación de pagos de Cesiones ----------------- */

import React, {
  useState,
  useEffect,
  useRef,
  useCallback
} from 'react';

import {
  TextField,
  Box,
  Divider,
  Button,
  Typography,
  Tooltip,
  FormControl,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Card,
  CardContent,
  CardHeader,
  CircularProgress
} from '@mui/material';

import api from '../../services/api.js'; // Api Interceptor en vez de Axios

import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { CustomToolbar } from "../../components/datagrid/CustomToolbar";
import DataGridSkeleton from "../../components/datagrid/DataGridSkeleton";

import { useAuth } from "../../context/AuthContext"; // token

import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves

import { normalizeRut } from "../utils/rutUtils";
import { formatFecha } from "../utils/dateUtils";
import { formatoCLP } from "../utils/montoclpUtils";

import {
  RiFilePdf2Fill,
  RiSave3Fill,
  RiReplyAllFill,
  RiFileExcel2Fill,
  RiFileList2Fill,
  RiSlackFill
} from 'react-icons/ri';

import * as XLSX from 'xlsx';

import { v4 as uuidv4 } from 'uuid';


const Conciliacion = ({ modo }) => {
  const { user } = useAuth();

  const [datapagos, setPagos] = useState([]); // El estado que guardará los datos procesados
  const [datacesiones, setCesiones] = useState([]);
  const [loading, setLoading] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [rowDetails, setRowDetails] = useState(null);
  const [bancos, setBancos] = useState([]);
  const [idban, setIdban] = useState(0);
  const [totalMontosces, setTotalMontosces] = useState(0); // Estado para almacenar el total de montos cesiones //
  const [totalMontoCargo, setTotalMontoCargo] = useState(0); // Estado para almacenar el total de pagos //
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [selectedBanco, setSelectedBanco] = useState("");

  /* Dialog de grabación */
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [saving, setSaving] = useState(false);

  /* Dialogo y confirmación */
  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes


  /* Mostrar los detalles de la fila seleccionada */
  const handleRowClick = (row) => {
    setRowDetails(row);
    setOpenDialog(true);
  };

  // cambia la fecha de dd-mm-aaaa a formato aaaa-mm-dd //
  function formatDate(date) {
    const [day, month, year] = date.split('-'); // Asumimos que la fecha está en formato DD-MM-YYYY
    return `${year}-${month}-${day}`; // Convertimos a YYYY-MM-DD
  }

  /* Función para cancelar y limpiar los arreglos */
  const handleCancel = async () => {
    setPagos([]);
    setCesiones([]);
    setIdban(0);
    setSelectedBanco("");
    setTotalMontosces(0);
    setTotalMontoCargo(0);
    setUploadedFile(null);
    await fetchBancos(); /* cargar de bancos nuevamente */
  };

  /* Grabación de la conciliación */
  const handleConfirmSave = async () => {
    setSaving(true);

    try {
      const uniqueID = uuidv4();

      const detalles = datapagos.map((row) => ({
        uuid: uniqueID,
        rut: normalizeRut(user.usuario),
        fechabco: formatDate(row.fecha),
        glosa: row.detalle,
        monto: parseFloat(row.montoCargo),
        banco: idban,
      }));

      const cesiones = datacesiones.map((row) => ({
        idces: row.idces,
        uuid: uniqueID,
        idpago: row.id,
      }));

      const responseConciliacion = await api.post("/conciliacion/addconciliacion", {
        detalles,
        cesiones,
      });

      if (responseConciliacion.data?.success) {
        showFeedback({
          message: "La conciliación fue grabada exitosamente.",
          severity: "success",
        });

        setOpenConfirmDialog(false);
        handleCancel();
      } else {
        showFeedback({
          message: "Hubo un error al guardar los detalles.",
          severity: "error",
        });
      }
    } catch (error) {
      showFeedback({
        message:
          "No fue posible obtener su solicitud, por favor intente más tarde.",
        severity: "error",
      });
    } finally {
      setSaving(false);
    }
  };

  /* grabar comprobante de conciliación */
  const saveSelectedData = () => {
    if (datapagos.length === 0) {
      showFeedback({
        message: "No se encontraron pagos en el archivo excel",
        severity: "warning",
      });
      return;
    }

    setOpenConfirmDialog(true);
  };

  /* Manejo cambio de banco */
  const handleSelectChange = (event) => {
    const value = event.target.value;

    setSelectedBanco(value); // ✅ guardar selección

    if (value === 0) {
      setIdban(0);
      setCesiones([]);
      return;
    }

    try {
      const { banco, idcomp } = JSON.parse(value);

      setIdban(banco);
      fetchCesiones(banco, idcomp);

    } catch (error) {
      showFeedback({
        message: "Error al obtener el banco seleccionado",
        severity: "error",
      });
    }
  };

 
  /* cargar bancos desde nominas de pago */
  const fetchBancos = useCallback(async () => {
    try {

      const RutCli = normalizeRut(user.usuario);

      const response = await api.post("/pagos/getbancospagos", {
        RutCli
      });

      if (response.data.success && response.data.rows) {
        setBancos(response.data.rows);
      } else {
        setBancos([]);
      }

    } catch (error) {
      setBancos([]);
    }
  }, [user]);

  /* cargar las cesiones al montar el componente */
  useEffect(() => {
    const fetchData = async () => {
      await fetchBancos();
    };
    fetchData();
  }, [fetchBancos]);

  /* Cargar las cesiones */
  const fetchCesiones = async (idban, idcomp) => {

    setLoading(true);

    try {

      const RutCli = normalizeRut(user.usuario);

      const response = await api.post("/pagos/getnominapagos", {
        RutCli,
        idban,
        idcomp
      });

      if (response.data.success && response.data.rows) {
        setCesiones(response.data.rows);

        /* Calcular la suma total de los montos */
        const totalMontosces = response.data.rows.reduce((sum, item) => sum + (item.montoces || 0), 0);
        setTotalMontosces(totalMontosces);

      } else {
        setCesiones([]);
      }

    } catch (err) {
      showFeedback({
        message:
          "No fue posible obtener su solicitud, por favor intente más tarde.",
        severity: "warning",
      });

    } finally {
      setLoading(false);
    }
  };

  /* helper para formato de monto clp */
  const renderMontoCLP = (value) => (
    <Box
      sx={{
        textAlign: 'center',
        fontSize: '0.9rem',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        width: '100%',
        // fontWeight: 'bold',
      }}
    >
      {formatoCLP(value)}
    </Box>
  );


  // Configuración de MUI DataGrid de pagos //
  const columnspagos = [

    {
      field: 'fecha',
      headerName: 'Fecha',
      width: 200,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
      renderHeader: () => (
        <Tooltip title="Fecha del Pago" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Fecha
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'detalle',
      headerName: "Detalle",
      width: 400,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Detalle de Pago" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Detalle
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'montoCargo',
      headerName: 'Monto Cargo',
      width: 200,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => {
        return (
          <Tooltip title='Monto del Cargo' arrow
            placement="top"
          >
          <span
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                fontWeight: 'bold',
                cursor: 'help',
              }}
            >
              Monto Cargo
            </span>
          </Tooltip>
        );
      },
      renderCell: (params) => {
        const monto = params.value;
        return (
          <div
            style={{
              textAlign: 'center',
              fontSize: '0.9rem',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              width: '100%',
              fontWeight: 'bold',
            }}
          >
            {formatoCLP(monto)}
          </div>
        );
      },
    },
  ];

  // Configuración de MUI DataGrid de cesiones //
  const columnsCesiones = [
    {
      field: 'pdf',
      headerName: 'PDF',
      width: 50,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,

      renderCell: (params) => {
        const { uuid } = params.row;

        const handleOpenPDF = async () => {
          if (!uuid) return;

          try {
            const response = await api.post('/cesiones/getcesionespdf',
              { uuid },
              { responseType: 'blob' }
            );

            const pdfBlob = new Blob([response.data], {
              type: 'application/pdf',
            });

            const url = window.URL.createObjectURL(pdfBlob);
            window.open(url, '_blank');

            setTimeout(() => {
              window.URL.revokeObjectURL(url);
            }, 1000);

          } catch (error) {
            showFeedback({
              message: 'No fue posible obtener el Pdf',
              severity: 'error',
            });
          }
        };

        return (
          <Button
            variant="contained"
            aria-label="Abrir PDF"
            onClick={handleOpenPDF}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.primaryAction,
              color: (theme) => theme.custom.ui.primaryActionText,
              minWidth: 0,
              padding: 0,
              width: 32,
              height: 24,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.primaryActionHover,
              },
            }}
          >
            <RiFilePdf2Fill size={20} />
          </Button>
        );
      },
    },
    {
      field: 'detalle',
      headerName: "Info",
      width: 70,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,
      renderCell: (params) => (
        <Button
          variant="contained"
          onClick={() => handleRowClick(params.row)}
          sx={{
            backgroundColor: (theme) => theme.custom.ui.primaryAction,
            color: (theme) => theme.custom.ui.primaryActionText,
            minWidth: 0,
            padding: 0,
            width: 32,
            height: 24,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.primaryActionHover,
            },
          }}
        >
          <RiFileList2Fill size={22} />
        </Button>
      ),
    },
    {
      field: 'feccesion',
      headerName: 'Fecha Ces.',
      width: 140,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => formatFecha(params.value),
    },
    {
      field: 'montoces',
      headerName: "Monto Ces.",
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return renderMontoCLP(params.value);
      },
    },
    {
      field: 'rutcedente',
      headerName: "Cedente",
      width: 130,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Rut del Cedente" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Cedente
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'nomcedente',
      headerName: "Nombre",
      width: 200,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Nombre del Cedente" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Nombre
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'rutcesionario',
      headerName: "Cesionario",
      width: 140,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Rut del Cesionario" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Cesionario
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'nomcesionario',
      headerName: "Nombre",
      width: 200,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Nombre del Cesionario" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Nombre
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'tipodte',
      headerName: "Tipdoc",
      width: 300,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="Tipo de Docto" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Tipdoc
          </span>
        </Tooltip>
      ),
    },
    {
      field: 'folio',
      headerName: "Folio",
      width: 120,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderHeader: () => (
        <Tooltip title="N° de Docto" arrow
          placement="top"
        >
        <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              fontWeight: 'bold',
              cursor: 'help',
            }}
          >
            Folio
          </span>
        </Tooltip>
      ),
    },
  ];

  // subir archivo excel con la cartola del banco //
  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setUploadedFile(file);

    /* Resetear o limpiar los datos antes de procesar el nuevo archivo (por precaución) */
    setPagos([]);
    setTotalMontoCargo(0);

    const reader = new FileReader();

    reader.onload = (event) => {
      const data = event.target.result;

      /* Usamos readAsArrayBuffer para leer el archivo correctamente */
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      let rowsData = [];
      let tempTotalMontoCargo = 0;

      /* Procesamos los datos, empezando desde la fila que contiene los datos reales (índice 2) */
      for (let i = 3; i < json.length; i++) { /* Comenzar desde la fila 3 (índice 2) */
        const row = json[i];

        /* Verificar que la fila tiene al menos 3 columnas */
        if (row && row.length >= 3) {
          // console.log('row[0]:',row[0]);  /* fecha */
          // console.log('row[1]:',row[1]);  /* descripción */
          // console.log('row[2]:',row[2]);  /* cargo */
          // console.log('row[3]:',row[3]);  /* abono */

          const fecha = row[0];     /* fecha */
          const detalle = row[1];   /* descripción */
          let montoCargo = row[2];  /* abono */

          montoCargo = montoCargo ? parseFloat(montoCargo) : 0;

          /*
            Expresión regular para validar el detalle busca rut y monto
            Solo agregar si montoCargo es mayor que 0 y el detalle cumple con la expresión regular
          */

          // const regexDetalle = /^\d{9}[a-zA-Z0-9]\s.*/;
          // const regexSegmento = /^\S+/; // Captura hasta el primer espacio

          // const matchDetalle = detalle.match(regexDetalle);
          // const matchSegmento = detalle.match(regexSegmento); // Aquí extraemos el segmento

          /* Expresión regular para validar el detalle */
          // if (!isNaN(montoCargo) && montoCargo > 0 && matchDetalle && matchSegmento) {
          // Comprobar si el rut (matchSegmento[0]) está en el estado datacesiones

          if (parseFloat(totalMontosces) === parseFloat(montoCargo)) {
              const isMatch = datacesiones.some(session => 
              parseFloat(totalMontosces) === parseFloat(montoCargo)
              // session.rutcesionario === matchSegmento[0] && totalMontosces === montoCargo
            );
            if (isMatch) {
              rowsData.push({
                id: rowsData.length + 1, // ✅ ID único para DataGrid
                fecha,
                detalle,
                montoCargo: montoCargo.toFixed(2), // Aseguramos que tenga 2 decimales
                // rutces: matchSegmento[0], // Agregar el segmento encontrado
              });
              tempTotalMontoCargo += montoCargo;
            }
          }
        }
      }
      /* Actualizar el estado con los datos procesados */
      setPagos(rowsData);

      /* Establecer el total de montoCargo en el estado */
      setTotalMontoCargo(tempTotalMontoCargo.toFixed(2));

      if (rowsData.length === 0) {
        showFeedback({
          message:
            "No se encontraron datos válidos",
          severity: "error",
        });
      }
    };
    // Usamos readAsArrayBuffer
    reader.readAsArrayBuffer(file);

    // Limpiar el valor del input después de cada carga
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        pt: 0,
        overflow: 'visible'
      }}>

      {/* Barra de Controles */}
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        alignItems="center"
        sx={{
          mb: 1,
          flexShrink: 0,       // 👈 NO se colapsa
        }}
      >
        {/* Rut */}
        <TextField
          label="Rut"
          value={user?.usuario || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: { shrink: true },
          }}
          sx={{
            minWidth: 140,
            flexShrink: 0,
            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
              textAlign: 'center',
              letterSpacing: '0.03em',
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        {/* Nombre */}
        <TextField
          label="Cliente"
          value={user?.nombre || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          sx={{
            minWidth: 260,
            flexGrow: 1,
            flexShrink: 0,

            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        {/* Selector de Banco */}
        <FormControl fullWidth required sx={{ width: '300px' }}>
          <InputLabel id="banco-label" sx={{ marginTop: '2px' }}>Banco</InputLabel>
          <Select
            labelId="banco-label"
            id="banco-select"
            value={selectedBanco}
            label="Banco"
            onChange={handleSelectChange}
            sx={{
              height: '40px',
              '& .MuiOutlinedInput-root': { height: '40px' },
              '& .MuiSelect-select': { textAlign: 'center' }
            }}
          >
            <MenuItem value={0}>✨ Seleccionar Banco</MenuItem>
            {bancos.map((banco) => {
              const formattedFechaNom = new Date(banco.fechanom).toLocaleDateString();
              const formattedMonto = banco.monto.toLocaleString();

              const value = JSON.stringify({
                banco: banco.banco,
                idcomp: banco.idcomp
              });

              return (
                <MenuItem key={banco.idcomp} value={value} sx={{ fontSize: '12px' }}>
                  {`${banco.nomban} - ID Nómina: ${banco.idcomp} - Fecha: ${formattedFechaNom} - Monto: ${formattedMonto}`}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        {/* Input file oculto */}
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileUpload}
          style={{ display: 'none' }} // Ocultar el input file
        />

        {/* Botón para disparar el input de carga de archivo */}
        <Tooltip title="Seleccionar archivo para cargar" placement="top" arrow>
          <span>
            <Button
              variant="contained"
              onClick={() => fileInputRef.current.click()}
              disabled={datacesiones.length === 0}
              sx={{
                width: '180px',
                height: '40px',
                textTransform: 'none',
                backgroundColor: '#3498db',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#0000FF',
                  color: 'white',
                },
                '& .MuiButton-startIcon': { color: 'white' },
              }}
            >
              <RiFileExcel2Fill className="m-2" style={{ fontSize: '1.5rem' }} />
              Cargar Pagos
            </Button>
          </span>
        </Tooltip>



        {/* Botón Grabar */}
        <Tooltip title="Grabar Pagos" placement="top" arrow>
          <span>
            <Button
              variant="contained"
              onClick={saveSelectedData}
              disabled={datacesiones.length === 0 || datapagos.length === 0}
              sx={{
                width: 130,
                height: 40,
                textTransform: 'none',

                backgroundColor: (theme) => theme.custom.ui.primaryAction,
                color: (theme) => theme.custom.ui.primaryActionText,

                '&:hover': {
                  backgroundColor: (theme) =>
                    theme.custom.ui.primaryActionHover,
                },

                '&.Mui-disabled': {
                  backgroundColor: (theme) =>
                    theme.custom.ui.disabledBg,
                  color: (theme) =>
                    theme.custom.ui.disabledText,
                },
              }}
              startIcon={<RiSave3Fill size={18} />}
            >
              Grabar
            </Button>
          </span>
        </Tooltip>

        {/* Botón Cancelar */}
        <Tooltip title="Cancelar Todo" placement="top" arrow>
          <Button
            variant="contained"
            onClick={handleCancel}
            sx={{
              width: 130,
              height: 40,
              textTransform: 'none',

              backgroundColor: (theme) => theme.custom.ui.secondaryActionBg,
              color: (theme) => theme.custom.ui.secondaryActionText,
              border: (theme) =>
                `1px solid ${theme.custom.ui.secondaryActionBorder}`,

              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.secondaryActionBgHover,
              },

              '&.Mui-disabled': {
                backgroundColor: (theme) =>
                  theme.custom.ui.disabledBg,
                color: (theme) =>
                  theme.custom.ui.disabledText,
              },
            }}
            startIcon={<RiReplyAllFill size={18} />}
          >
            Cancelar
          </Button>
        </Tooltip>

      </Stack>


      {/* Cards de Totales */}
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="flex-start"
        gap={1}   // espacio horizontal y vertical
        sx={{ mt: 1, mb: 1 }}
      >

        {/* CARD 1 – Archivo xls Cargado */}
        <Card
          sx={{
            width: 400,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Archivo Cargado
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {uploadedFile?.name || "—"}
            </Typography>
          </Box>
        </Card>

        {/* CARD 2 - Monto Cesiones */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Monto Cesiones
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalMontosces)}
            </Typography>
          </Box>
        </Card>

        {/* CARD 3 – Monto Total Cargos */}
        <Card
          sx={{
            width: 130,
            minHeight: 52, // 👈 CLAVE: referencia vertical
            backgroundColor: (theme) => theme.custom.ui.surfaceBg,
            borderRadius: 2,
            boxShadow: (theme) => theme.custom.ui.surfaceShadow,
            display: 'flex', // 👈 importante
          }}
        >
          <Box
            sx={{
              flex: 1,                    // 👈 ocupa toda la altura
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',   // 👈 centrado real
              gap: 0.25,
              px: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                textAlign: 'center',
                color: (theme) => theme.custom.ui.brandAccent, // 👈 color de marca
                fontSize: '0.75rem',
                fontWeight: 600,       // 👈 un poco más de presencia
                letterSpacing: '0.02em',
              }}
            >
              Total Pagos
            </Typography>

            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{
                color: (theme) => theme.custom.ui.textPrimary,
                fontSize: '0.85rem',
                lineHeight: 1.15,
                m: 0,
              }}
            >
              {formatoCLP(totalMontoCargo)}
            </Typography>
          </Box>
        </Card>

      </Stack>

      {/* Configuración MIU DataGrid cabecera */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 210px)', /* ajusta según tu layout */
          minHeight: 0,
        }}
      >
        <DataGrid
          rows={datapagos}
          columns={columnspagos}
          getRowId={(row) => row.id}
          loading={loading}
          density="compact"
          rowHeight={38}
          headerHeight={40}
          disableRowSelectionOnClick

          pagination
          initialState={{
            pagination: { paginationModel: { pageSize: 10, page: 0 } },
            density: 'compact',
          }}
          pageSizeOptions={[10, 20, 50, 100]}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}

          slots={{
            toolbar: CustomToolbar,
            loadingOverlay: DataGridSkeleton,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 400 },
            },
          }}
          sx={{
            height: '100%',
            flex: 1,
            width: '100%',
            minWidth: 720,      /* scroll horizontal cuando corresponde */
            border: 'none',
            /* accesibilidad - foco */
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
      </Box>


      {/* Configuración MIU DataGrid cesiones */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 210px)', /* ajusta según tu layout */
          minHeight: 0,
        }}
       >
        <DataGrid
          rows={datacesiones}
          columns={columnsCesiones}
          getRowId={(row) => row.idces}
          loading={loading}
          density="compact"
          rowHeight={38}
          headerHeight={40}
          disableRowSelectionOnClick

          pagination
          initialState={{
            pagination: { paginationModel: { pageSize: 10, page: 0 } },
            density: 'compact',
          }}
          pageSizeOptions={[10, 20, 50, 100]}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}

          slots={{
            toolbar: CustomToolbar,
            loadingOverlay: DataGridSkeleton,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 400 },
            },
          }}
          sx={{
            height: '100%',
            flex: 1,
            width: '100%',
            minWidth: 720,      /* scroll horizontal cuando corresponde */
            border: 'none',
            /* accesibilidad - foco */
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
      </Box>

      <Typography variant="caption" color="text.secondary">
        {datacesiones.length.toLocaleString('es-CL')} registros encontrados
      </Typography>


      {/* Dialog para mostrar los detalles de la fila */}
      <Dialog
        open={openDialog}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          setOpenDialog(false);
        }}
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth
        aria-labelledby="cesion-detalle-title"
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 8,
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
              border: `1px solid ${theme.custom.ui.borderSubtle}`,
            }),
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          id="cesion-detalle-title"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
          }}
        >
          <Stack direction="row" spacing={1.2} alignItems="center">
            <RiSlackFill
              size={22}
              color="inherit"
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                letterSpacing: '0.04em',
                color: (theme) => theme.custom.ui.brandAccent,
              }}
            >
              Detalles de la Cesión
            </Typography>
          </Stack>

          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            size="small"
            sx={{
              backgroundColor: (theme) =>
                theme.custom.ui.secondaryActionBg,
              color: (theme) =>
                theme.custom.ui.secondaryActionText,
              border: (theme) =>
                `1px solid ${theme.custom.ui.secondaryActionBorder}`,
              '&:hover': {
                backgroundColor: (theme) =>
                  theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cerrar
          </Button>
        </DialogTitle>

        <Divider
          sx={{
            borderColor: (theme) => theme.custom.ui.borderSubtle,
            opacity: 0.9,
          }}
        />

        {/* CONTENIDO */}
        <DialogContent
          sx={{
            maxHeight: '75vh',
            overflowY: 'auto',
            px: 2,
            py: 2,
          }}
        >
          {rowDetails && (
            <Stack spacing={2}>
              {/* Datos del Contribuyente */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos del la Cesión"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />
                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Id Cesión', rowDetails.id],
                    ['Fecha Cesión', rowDetails.feccesion],
                    ['Rut Deudor', rowDetails.rutdeudor],
                    ['Razón Social', rowDetails.nomdeudor],
                    ['Dirección', rowDetails.domdeudor],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>

              {/* Datos del Cedente */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Cedente"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Rut Cedente', rowDetails.rutcedente],
                    ['Razón Social', rowDetails.nomcedente],
                    ['Dirección', rowDetails.domcedente],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>


              {/* Datos del Cesionario */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Cesionario"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Rut Cesionario', rowDetails.rutcesionario],
                    ['Razón Social', rowDetails.nomcesionario],
                    ['Dirección', rowDetails.domcesionario],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>


              {/* Datos Nota de Crédito */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) =>
                    theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Nota Crédito"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) =>
                      theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    ['Folio Nota Crédito', rowDetails.folionc],
                    ['Fecha Emisión', rowDetails.feceminc],
                    ['Monto', rowDetails.montonc],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>

              {/* Datos Estado de Pago */}
              <Card
                sx={{
                  backgroundColor: (theme) => theme.custom.ui.surfaceBg,
                  borderRadius: 8,
                  boxShadow: (theme) => theme.custom.ui.surfaceShadow,
                }}
              >
                <CardHeader
                  title="Datos Estado de Pago"
                  sx={{
                    py: 1.5,
                    backgroundColor: (theme) => theme.custom.ui.modalBg,
                    borderBottom: (theme) =>
                      `1px solid ${theme.custom.ui.borderSubtle}`,
                    '& .MuiCardHeader-title': {
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                      color: (theme) => theme.custom.ui.brandAccent,
                    },
                  }}
                />

                <CardContent sx={{ pt: 2 }}>
                  {[
                    [
                      'Estado',
                      rowDetails.pagada === 0
                        ? 'Pendiente'
                        : rowDetails.pagada === 1
                        ? 'En Nómina'
                        : 'Pagada'
                    ],
                    ['Comp. Pago Nro', rowDetails.idpago],
                    [
                      'Fecha de Pago',
                      rowDetails.fechapago
                        ? new Date(rowDetails.fechapago)
                            .toLocaleDateString('es-CL')
                        : '-'
                    ],
                    ['Cant. Documentos', rowDetails.cantidad],
                    ['Monto Total Comp', rowDetails.monto],
                    ['Conciliado', rowDetails.idpago],
                  ].map(([label, value]) => (
                    <Stack
                      key={label}
                      direction="row"
                      spacing={2}
                      alignItems="flex-start"
                      // mb={1}
                    >
                      <Typography
                        sx={{
                          width: 160,
                          color: (theme) => theme.custom.ui.textSecondary,
                          fontSize: '0.85rem',
                          flexShrink: 0,
                        }}
                      >
                        {label}
                      </Typography>

                      <Typography
                        sx={{
                          color: (theme) => theme.custom.ui.textPrimary,
                          fontSize: '0.9rem',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {value ?? '-'}
                      </Typography>
                    </Stack>
                  ))}
                </CardContent>
              </Card>
            </Stack>
          )}
        </DialogContent>
      </Dialog>

      {/* Confirmar grabación */}
      <Dialog
        open={openConfirmDialog}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenConfirmDialog(false);
        }}
        maxWidth="xs"
        fullWidth
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 3,
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
            }),
          },
        }}
      >
        <DialogTitle
          sx={{
            color: (theme) => theme.custom.ui.brandAccent,
            fontWeight: 600,
            fontSize: "1rem",
          }}
        >
          Confirmar acción
        </DialogTitle>

        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            ¿Desea grabar la conciliación de pagos?
          </Typography>

          <Typography variant="caption" color="text.secondary">
            Se grabarán {datapagos.length} registro(s).
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenConfirmDialog(false)}
            sx={{
              backgroundColor: (theme) =>
                theme.custom.ui.secondaryActionBg,
              color: (theme) =>
                theme.custom.ui.secondaryActionText,
              border: (theme) =>
                `1px solid ${theme.custom.ui.secondaryActionBorder}`,
              "&:hover": {
                backgroundColor: (theme) =>
                  theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            onClick={handleConfirmSave}
            disabled={saving}
            sx={{
              backgroundColor: (theme) =>
                theme.custom.ui.primaryAction,
              color: (theme) =>
                theme.custom.ui.primaryActionText,
              "&:hover": {
                backgroundColor: (theme) =>
                  theme.custom.ui.primaryActionHover,
              },
            }}
          >
            {saving ? <CircularProgress size={18} /> : "Sí, Grabar"}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default Conciliacion;
